"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryByDialCode = exports.getCountryByCode = exports.getCountryData = void 0;
var google_libphonenumber_1 = require("google-libphonenumber");
// All country names
var allCountryNames = {
    AD: 'Andorra',
    AE: 'United Arab Emirates',
    AF: 'Afghanistan',
    AG: 'Antigua and Barbuda',
    AI: 'Anguilla',
    AL: 'Albania',
    AM: 'Armenia',
    AO: 'Angola',
    AR: 'Argentina',
    AS: 'American Samoa',
    AT: 'Austria',
    AU: 'Australia',
    AW: 'Aruba',
    AZ: 'Azerbaijan',
    BA: 'Bosnia and Herzegovina',
    BB: 'Barbados',
    BD: 'Bangladesh',
    BE: 'Belgium',
    BF: 'Burkina Faso',
    BG: 'Bulgaria',
    BH: 'Bahrain',
    BI: 'Burundi',
    BJ: 'Benin',
    BL: 'Saint Barthélemy',
    BM: 'Bermuda',
    BN: 'Brunei',
    BO: 'Bolivia',
    BR: 'Brazil',
    BS: 'Bahamas',
    BT: 'Bhutan',
    BW: 'Botswana',
    BY: 'Belarus',
    BZ: 'Belize',
    CA: 'Canada',
    CD: 'Democratic Republic of the Congo',
    CF: 'Central African Republic',
    CG: 'Republic of the Congo',
    CH: 'Switzerland',
    CI: 'Ivory Coast',
    CL: 'Chile',
    CM: 'Cameroon',
    CN: 'China',
    CO: 'Colombia',
    CR: 'Costa Rica',
    CU: 'Cuba',
    CV: 'Cape Verde',
    CY: 'Cyprus',
    CZ: 'Czech Republic',
    DE: 'Germany',
    DJ: 'Djibouti',
    DK: 'Denmark',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    DZ: 'Algeria',
    EC: 'Ecuador',
    EE: 'Estonia',
    EG: 'Egypt',
    EH: 'Western Sahara',
    ER: 'Eritrea',
    ES: 'Spain',
    ET: 'Ethiopia',
    FI: 'Finland',
    FJ: 'Fiji',
    FK: 'Falkland Islands',
    FM: 'Micronesia',
    FO: 'Faroe Islands',
    FR: 'France',
    GA: 'Gabon',
    GB: 'United Kingdom',
    GD: 'Grenada',
    GE: 'Georgia',
    GF: 'French Guiana',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GL: 'Greenland',
    GM: 'Gambia',
    GN: 'Guinea',
    GP: 'Guadeloupe',
    GQ: 'Equatorial Guinea',
    GR: 'Greece',
    GT: 'Guatemala',
    GU: 'Guam',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HK: 'Hong Kong',
    HN: 'Honduras',
    HR: 'Croatia',
    HT: 'Haiti',
    HU: 'Hungary',
    ID: 'Indonesia',
    IE: 'Ireland',
    IL: 'Israel',
    IN: 'India',
    IQ: 'Iraq',
    IR: 'Iran',
    IS: 'Iceland',
    IT: 'Italy',
    JM: 'Jamaica',
    JO: 'Jordan',
    JP: 'Japan',
    KE: 'Kenya',
    KG: 'Kyrgyzstan',
    KH: 'Cambodia',
    KI: 'Kiribati',
    KM: 'Comoros',
    KN: 'Saint Kitts and Nevis',
    KP: 'North Korea',
    KR: 'South Korea',
    KW: 'Kuwait',
    KY: 'Cayman Islands',
    KZ: 'Kazakhstan',
    LA: 'Laos',
    LB: 'Lebanon',
    LC: 'Saint Lucia',
    LI: 'Liechtenstein',
    LK: 'Sri Lanka',
    LR: 'Liberia',
    LS: 'Lesotho',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    LV: 'Latvia',
    LY: 'Libya',
    MA: 'Morocco',
    MC: 'Monaco',
    MD: 'Moldova',
    ME: 'Montenegro',
    MF: 'Saint Martin',
    MG: 'Madagascar',
    MH: 'Marshall Islands',
    MK: 'North Macedonia',
    ML: 'Mali',
    MM: 'Myanmar',
    MN: 'Mongolia',
    MO: 'Macau',
    MP: 'Northern Mariana Islands',
    MQ: 'Martinique',
    MR: 'Mauritania',
    MS: 'Montserrat',
    MT: 'Malta',
    MU: 'Mauritius',
    MV: 'Maldives',
    MW: 'Malawi',
    MX: 'Mexico',
    MY: 'Malaysia',
    MZ: 'Mozambique',
    NA: 'Namibia',
    NC: 'New Caledonia',
    NE: 'Niger',
    NF: 'Norfolk Island',
    NG: 'Nigeria',
    NI: 'Nicaragua',
    NL: 'Netherlands',
    NO: 'Norway',
    NP: 'Nepal',
    NR: 'Nauru',
    NU: 'Niue',
    NZ: 'New Zealand',
    OM: 'Oman',
    PA: 'Panama',
    PE: 'Peru',
    PF: 'French Polynesia',
    PG: 'Papua New Guinea',
    PH: 'Philippines',
    PK: 'Pakistan',
    PL: 'Poland',
    PM: 'Saint Pierre and Miquelon',
    PR: 'Puerto Rico',
    PS: 'Palestine',
    PT: 'Portugal',
    PW: 'Palau',
    PY: 'Paraguay',
    QA: 'Qatar',
    RE: 'Réunion',
    RO: 'Romania',
    RS: 'Serbia',
    RU: 'Russia',
    RW: 'Rwanda',
    SA: 'Saudi Arabia',
    SB: 'Solomon Islands',
    SC: 'Seychelles',
    SD: 'Sudan',
    SE: 'Sweden',
    SG: 'Singapore',
    SH: 'Saint Helena',
    SI: 'Slovenia',
    SJ: 'Svalbard and Jan Mayen',
    SK: 'Slovakia',
    SL: 'Sierra Leone',
    SM: 'San Marino',
    SN: 'Senegal',
    SO: 'Somalia',
    SR: 'Suriname',
    ST: 'São Tomé and Príncipe',
    SV: 'El Salvador',
    SY: 'Syria',
    SZ: 'Eswatini',
    TC: 'Turks and Caicos Islands',
    TD: 'Chad',
    TG: 'Togo',
    TH: 'Thailand',
    TJ: 'Tajikistan',
    TK: 'Tokelau',
    TL: 'Timor-Leste',
    TM: 'Turkmenistan',
    TN: 'Tunisia',
    TO: 'Tonga',
    TR: 'Turkey',
    TT: 'Trinidad and Tobago',
    TV: 'Tuvalu',
    TW: 'Taiwan',
    TZ: 'Tanzania',
    UA: 'Ukraine',
    UG: 'Uganda',
    US: 'United States',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VA: 'Vatican City',
    VC: 'Saint Vincent and the Grenadines',
    VE: 'Venezuela',
    VG: 'British Virgin Islands',
    VI: 'U.S. Virgin Islands',
    VN: 'Vietnam',
    VU: 'Vanuatu',
    WF: 'Wallis and Futuna',
    WS: 'Samoa',
    YE: 'Yemen',
    YT: 'Mayotte',
    ZA: 'South Africa',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
};
// Use all countries from allCountryNames
var supportedCountries = Object.keys(allCountryNames);
// Use allCountryNames directly
var countryNames = allCountryNames;
// Initialize phoneUtil with error handling
var phoneUtil;
try {
    phoneUtil = google_libphonenumber_1.PhoneNumberUtil.getInstance();
}
catch (error) {
    console.error('Failed to initialize PhoneNumberUtil:', error);
}
// Helper function to create country data with custom sorting
var createCountryData = function (preferredCountries) {
    if (preferredCountries === void 0) { preferredCountries = ['US', 'GB']; }
    return supportedCountries
        .map(function (code) {
        try {
            var dialCode = phoneUtil.getCountryCodeForRegion(code);
            var example = phoneUtil.getExampleNumber(code);
            return {
                code: code,
                name: countryNames[code],
                dialCode: "+".concat(dialCode),
                example: example
                    ? phoneUtil.format(example, google_libphonenumber_1.PhoneNumberFormat.NATIONAL) || ''
                    : '',
            };
        }
        catch (error) {
            // Fallback for countries that might have issues with phoneUtil
            console.warn("Failed to get phone data for country ".concat(code, ":"), error);
            return {
                code: code,
                name: countryNames[code],
                dialCode: '+1', // Fallback dial code
                example: '',
            };
        }
    })
        .sort(function (a, b) {
        // Sort by preferred countries first, then alphabetically
        var aIndex = preferredCountries.indexOf(a.code);
        var bIndex = preferredCountries.indexOf(b.code);
        // If both are preferred countries, sort by their order in preferredCountries
        if (aIndex !== -1 && bIndex !== -1) {
            return aIndex - bIndex;
        }
        // If only a is preferred, it comes first
        if (aIndex !== -1)
            return -1;
        // If only b is preferred, it comes first
        if (bIndex !== -1)
            return 1;
        // Neither is preferred, sort alphabetically
        return a.name.localeCompare(b.name);
    });
};
// Pre-compute default country data for better performance (backward compatibility)
var DEFAULT_COUNTRY_DATA = createCountryData();
var getCountryData = function (preferredCountries) {
    // If no preferred countries specified, return the pre-computed default
    if (!preferredCountries ||
        (preferredCountries.length === 2 &&
            preferredCountries[0] === 'US' &&
            preferredCountries[1] === 'GB')) {
        return DEFAULT_COUNTRY_DATA;
    }
    // Filter to only valid country codes and create new sorted data
    var validPreferredCountries = preferredCountries.filter(function (code) { return code in allCountryNames; });
    return createCountryData(validPreferredCountries);
};
exports.getCountryData = getCountryData;
var getCountryByCode = function (code) {
    return DEFAULT_COUNTRY_DATA.find(function (country) { return country.code === code; });
};
exports.getCountryByCode = getCountryByCode;
var getCountryByDialCode = function (dialCode) {
    return DEFAULT_COUNTRY_DATA.find(function (country) { return country.dialCode === dialCode; });
};
exports.getCountryByDialCode = getCountryByDialCode;
//# sourceMappingURL=countryData.js.map